import { render } from "./Klien.vue?vue&type=template&id=88119bb8"
import script from "./Klien.vue?vue&type=script&lang=js"
export * from "./Klien.vue?vue&type=script&lang=js"

import "./Klien.vue?vue&type=style&index=0&id=88119bb8&lang=css"
script.render = render

export default script